/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RececaoFontesSeladasCriteriaDto } from '../models/rececao-fontes-seladas-criteria-dto';
import { RececaoFontesSeladasDto } from '../models/rececao-fontes-seladas-dto';
import { RececaoFontesSeladasFormDto } from '../models/rececao-fontes-seladas-form-dto';
import { RececaoFontesSeladasPageDto } from '../models/rececao-fontes-seladas-page-dto';


/**
 * Avisos de Recepção de Fontes Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class RececaoFontesSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAvisosRececaoFs
   */
  static readonly GetAvisosRececaoFsPath = '/rececao-fontes-seladas';

  /**
   * Pesquisar Avisos de Recepção de Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvisosRececaoFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvisosRececaoFs$Response(params?: {
    criteria?: RececaoFontesSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<RececaoFontesSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, RececaoFontesSeladasService.GetAvisosRececaoFsPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RececaoFontesSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Avisos de Recepção de Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvisosRececaoFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvisosRececaoFs(params?: {
    criteria?: RececaoFontesSeladasCriteriaDto;
  }): Observable<RececaoFontesSeladasPageDto> {

    return this.getAvisosRececaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<RececaoFontesSeladasPageDto>) => r.body as RececaoFontesSeladasPageDto)
    );
  }

  /**
   * Path part for operation getAvisoRececaoFs
   */
  static readonly GetAvisoRececaoFsPath = '/rececao-fontes-seladas/{id}';

  /**
   * Detalhe de um Aviso de Recepção de Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvisoRececaoFs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvisoRececaoFs$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<RececaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, RececaoFontesSeladasService.GetAvisoRececaoFsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RececaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Detalhe de um Aviso de Recepção de Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAvisoRececaoFs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvisoRececaoFs(params: {
    id: number;
  }): Observable<RececaoFontesSeladasDto> {

    return this.getAvisoRececaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<RececaoFontesSeladasDto>) => r.body as RececaoFontesSeladasDto)
    );
  }

  /**
   * Path part for operation updateAvisoRececaoFs
   */
  static readonly UpdateAvisoRececaoFsPath = '/rececao-fontes-seladas/{id}';

  /**
   * Editar Aviso de Recepção de Fontes Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAvisoRececaoFs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAvisoRececaoFs$Response(params: {
    id: number;
    body?: RececaoFontesSeladasFormDto
  }): Observable<StrictHttpResponse<RececaoFontesSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, RececaoFontesSeladasService.UpdateAvisoRececaoFsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RececaoFontesSeladasDto>;
      })
    );
  }

  /**
   * Editar Aviso de Recepção de Fontes Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAvisoRececaoFs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAvisoRececaoFs(params: {
    id: number;
    body?: RececaoFontesSeladasFormDto
  }): Observable<RececaoFontesSeladasDto> {

    return this.updateAvisoRececaoFs$Response(params).pipe(
      map((r: StrictHttpResponse<RececaoFontesSeladasDto>) => r.body as RececaoFontesSeladasDto)
    );
  }

}
